angular.module('core')
    .directive('responsiveFilters', function () {
        return {
            restrict: 'A',
            link: function (scope, $element, attrs) {
                function init() {
                    let ch = $element.parent().find('#content-header');
                    if (ch.length === 0)
                        return;

                    if ($element.parent().find('.filters-mobile-button').length > 0)
                        return;

                    let btn = angular.element('<button class="btn btn-default"><i class="fa fa-filter"></i></button>')
                    btn.on('click', () => {
                        $element.toggleClass('hidden-xs')
                    })
                    let btnComponent = angular.element('<div class="filters-mobile-button"><div class="btn-group-sm"></div></div>')
                    btnComponent.find('.btn-group-sm').append(btn)
                    $element.addClass('hidden-xs')
                    ch.after(btnComponent)
                }

                init()
                scope.$on('$includeContentLoaded', () => init())
            }
        }
    })
